<h1 matDialogTitle>Details for Stock Code {{data.stockCode}}</h1>

<mat-dialog-content>
    <mat-tab-group>
        <mat-tab label="Available Stock">
            <kendo-grid style="max-height: 250px" [kendoGridBinding]="stockOnHand" [scrollable]="true"
                [resizable]="true" [reorderable]="true" [sortable]="true" [loading]="loading">

                <kendo-grid-column [width]="160" field="warehouseDescription" title="Warehouse"></kendo-grid-column>
                <kendo-grid-column [width]="130" field="partCategory" title="Part Category"></kendo-grid-column>
                <kendo-grid-column [width]="130" class="td-number" field="qtyOnHand" title="Qty On Hand">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <div class="td-number">{{dataItem.qtyOnHand | number:'1.0-2'}}</div>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column [width]="130" class="td-number" field="qtyAllocated" title="Qty Allocated">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <div class="td-number">{{dataItem.qtyAllocated | number:'1.0-2'}}</div>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column [width]="130" class="td-number" field="availableQty" title="Qty Available">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <div class="td-number">{{dataItem.availableQty | number:'1.0-2'}}</div>
                    </ng-template>
                </kendo-grid-column>
            </kendo-grid>
        </mat-tab>

        <mat-tab label="Customer Prices">
            <kendo-grid style="max-height: 250px;" [kendoGridBinding]="prices" [scrollable]="true" [resizable]="true"
                [reorderable]="true" [sortable]="true" [loading]="loading">
                <kendo-grid-column [width]="140" field="applyPrice" title="Price Applied">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <div>
                            <mat-icon>{{dataItem.applyPrice === true ? 'check' : 'close'}}</mat-icon>
                        </div>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column [width]="160" field="customerClassDescription" title="Customer Class">
                </kendo-grid-column>
                <kendo-grid-column [width]="140" field="buyingGroup1" title="Buying Group"></kendo-grid-column>
                <kendo-grid-column [width]="130" field="priceCode" title="Price Code"></kendo-grid-column>
                <kendo-grid-column [width]="140" field="priceMethod" title="Price Method"></kendo-grid-column>
                <kendo-grid-column [width]="160" field="priceDescription" title="Price Description"></kendo-grid-column>
                <kendo-grid-column [width]="180" field="priceMethodWeight" title="Price Method Weight">
                </kendo-grid-column>
                <kendo-grid-column [width]="140" class="td-number" field="sellingPrice" title="Selling Price">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <div class="td-number">{{dataItem.sellingPrice | number:'1.2-2'}}</div>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column [width]="130" class="td-number" field="fixedPrice" title="Fixed Price">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <div class="td-number">{{dataItem.fixedPrice | number:'1.2-2'}}</div>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column [width]="130" class="td-number" field="discountPerc" title="Discount %">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <div class="td-number">{{dataItem.discountPerc | number:'1.2-2'}}</div>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column [width]="150" class="td-number" field="effectivePrice" title="Effective Price">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <div class="td-number">{{dataItem.effectivePrice | number:'1.2-2'}}</div>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column [width]="140" field="priceAllowed" title="Price Allowed">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <div>
                            <mat-icon>{{dataItem.priceAllowed === true ? 'check' : 'close'}}</mat-icon>
                        </div>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column [width]="150" field="contractPromo" title="Contract Promo"></kendo-grid-column>
            </kendo-grid>
        </mat-tab>

        <mat-tab [label]="sctsTitle">
            <kendo-grid style="max-height: 250px;" [kendoGridBinding]="scts" [scrollable]="true" [resizable]="true"
                [reorderable]="true" [sortable]="true" [loading]="loading">
                <kendo-grid-column [width]="140" field="stockCode" title="Stock Code"></kendo-grid-column>
                <kendo-grid-column [width]="170" field="isCurrentStockCode" title="Current Stock Code">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <div>
                            <mat-icon>{{dataItem.isCurrentStockCode === true ? 'check' : 'close'}}</mat-icon>
                        </div>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column [width]="160" field="sctSalesOrder" title="SCT SO"></kendo-grid-column>
                <kendo-grid-column [width]="160" field="sctSalesOrderLine" title="SCT SO Line #"></kendo-grid-column>
                <kendo-grid-column [width]="130" field="salesOrderLine" title="SO Line #"></kendo-grid-column>
                <kendo-grid-column [width]="140" field="orderStatus" title="Order Status"></kendo-grid-column>
                <kendo-grid-column [width]="140" class="td-number" field="orderQty" title="Order Qty">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <div class="td-number">{{dataItem.orderQty | number:'1.0-2'}}</div>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column [width]="200" field="warehouseDescription" title="Warehouse"></kendo-grid-column>
                <kendo-grid-column [width]="160" field="reqShipDate" title="Req. Ship Date">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        {{dataItem.reqShipDate | date: 'MMM d, yyyy'}}
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column [width]="160" field="orderDate" title="Order Date">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        {{dataItem.orderDate | date: 'MMM d, yyyy'}}
                    </ng-template>
                </kendo-grid-column>
            </kendo-grid>
        </mat-tab>

        <mat-tab [label]="jobsTitle">
            <kendo-grid style="max-height: 250px;" [kendoGridBinding]="jobs" [scrollable]="true" [resizable]="true"
                [reorderable]="true" [sortable]="true" [loading]="loading">
                <kendo-grid-column [width]="180" field="job" title="Job"></kendo-grid-column>
                <kendo-grid-column [width]="160" field="createdDate" title="Created Date">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        {{dataItem.createdDate | date: 'MMM d, yyyy'}}
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column [width]="200" field="plannedJobStartDate" title="Planned Start Date">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        {{dataItem.plannedJobStartDate | date: 'MMM d, yyyy'}}
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column [width]="200" field="plannedJobCompletionDate" title="Planned Completion Date">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        {{dataItem.plannedJobStartDate | date: 'MMM d, yyyy'}}
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column [width]="200" field="jobCompletedDate" title="Actual Completion Date">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        {{dataItem.jobCompletedDate | date: 'MMM d, yyyy'}}
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column [width]="140" field="jobComplete" title="Job Complete">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <div>
                            <mat-icon>{{dataItem.jobComplete === 'Y' ? 'check' : 'close'}}</mat-icon>
                        </div>
                    </ng-template>
                </kendo-grid-column>
            </kendo-grid>
        </mat-tab>

        <mat-tab [label]="mtoPosTitle">
            <kendo-grid style="max-height: 250px;" [kendoGridBinding]="mtoPos" [scrollable]="true" [resizable]="true"
                [reorderable]="true" [sortable]="true" [loading]="loading">
                <kendo-grid-column [width]="180" field="purchaseOrder" title="Purchase Order"></kendo-grid-column>
                <kendo-grid-column [width]="130" field="orderStatus" title="Order Status"></kendo-grid-column>
                <kendo-grid-column [width]="130" field="supplier" title="Supplier"></kendo-grid-column>
                <kendo-grid-column [width]="160" field="orderEntryDate" title="Order Placed">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        {{dataItem.orderEntryDate | date: 'MMM d, yyyy'}}
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column [width]="130" field="orderDueDate" title="Order Due">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        {{dataItem.orderDueDate | date: 'MMM d, yyyy'}}
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column [width]="130" field="memoDate" title="Memo Date">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        {{dataItem.memoDate | date: 'MMM d, yyyy'}}
                    </ng-template>
                </kendo-grid-column>

                <kendo-grid-column [width]="100" field="line" title="PO Line"></kendo-grid-column>
                <kendo-grid-column [width]="130" field="latestDueDate" title="Latest Due">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        {{dataItem.latestDueDate | date: 'MMM d, yyyy'}}
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column [width]="130" field="warehouse" title="Warehouse"></kendo-grid-column>
                <kendo-grid-column [width]="130" field="stockCode" title="Stock Code"></kendo-grid-column>
                <kendo-grid-column [width]="150" field="stockDes" title="Description"></kendo-grid-column>
                <kendo-grid-column [width]="130" field="orderQty" title="Order Qty"></kendo-grid-column>
                <kendo-grid-column [width]="130" field="receivedQty" title="Received Qty"></kendo-grid-column>

            </kendo-grid>
        </mat-tab>
        <!-- <mat-tab label="Inventory Movement">
            <kendo-grid style="max-height: 150px" [kendoGridBinding]="inventoryMovement" [scrollable]="true"
                [resizable]="true" [reorderable]="true" [sortable]="true" [loading]="loading">

                <kendo-grid-column [width]="160" field="entryDate" title="Movement Date">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        {{dataItem.entryDate | date: 'MMM d, yyyy'}}
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column [width]="300" field="warehouseDescription" title="Warehouse"></kendo-grid-column>
                <kendo-grid-column [width]="130" field="trnYear" title="Trn Year"></kendo-grid-column>
                <kendo-grid-column [width]="130" field="trnMonth" title="Trn Month"></kendo-grid-column>
                <kendo-grid-column [width]="130" field="reference" title="Reference"></kendo-grid-column>
                <kendo-grid-column [width]="130" field="movementType" title="Movement Type"></kendo-grid-column>
                <kendo-grid-column [width]="130" field="trnType" title="Trn Type"></kendo-grid-column>
                <kendo-grid-column [width]="130" class="td-number" field="trnQty" title="Trn Qty">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <div class="td-number">{{dataItem.trnQty | number:'1.0-2'}}</div>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column [width]="130" class="td-number" field="trnValue" title="Trn Value">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <div class="td-number">{{dataItem.trnValue | number:'1.2-2'}}</div>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column [width]="130" class="td-number" field="enteredCost" title="Entered Cost">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <div class="td-number">{{dataItem.enteredCost | number:'1.2-2'}}</div>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column [width]="130" class="td-number" field="unitCost" title="Unit Cost">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <div class="td-number">{{dataItem.unitCost | number:'1.2-2'}}</div>
                    </ng-template>
                </kendo-grid-column>
            </kendo-grid>
        </mat-tab> -->
    </mat-tab-group>

</mat-dialog-content>

<mat-dialog-actions>
    <button mat-button matDialogClose>Close</button>
</mat-dialog-actions>
